import React from 'react';

import { Form } from 'react-bootstrap';
import { filters } from './filters';
import Button from '../../shared/displayComponents/button/Button';

import './FilterBar.scss';

const FilterBar = ({
  handleSubmit,
  SubmitFilter,
  ResetForm,
  register,
  watch,
  showSaveSearch,
  onSaveSearch,
}) => {
  const { gender, years, sports } = filters;
  const { volleyball, basketball, soccer, beachVolleyball, iceHockey, waterPolo } = filters.positions;
  const selectedSport = watch('sport');

  const getOptions = () => {
    switch (selectedSport) {
      case 'Volleyball':
        return volleyball;
      case 'Beach Volleyball':
        return beachVolleyball;
      case 'Basketball':
        return basketball;
      case 'Soccer':
        return soccer;
      case 'Ice Hockey':
        return iceHockey;
      case 'Water Polo':
        return waterPolo;
      default:
        return [];
    }
  };

  const renderOptions = () => {
    const data = getOptions();
    return data.map(position => (
      <option value={position} key={position}>
        {position}
      </option>
    ));
  };

  return (
    <div className="filter__bar-wrapper">
        <Form onSubmit={handleSubmit(SubmitFilter)} className="filter__bar">
          <div className="filter__content">
            <Form.Group className="filter__group">
              <Form.Label className="filter__label">
                <i className="fas fa-futbol" /> Sport
              </Form.Label>
              <div className="filter__select-wrapper">
                <Form.Control
                  ref={register}
                  className="filter__select"
                  as="select"
                  name="sport"
                >
                  {sports.map(sport => (
                    <option value={sport} key={sport}>
                      {sport}
                    </option>
                  ))}
                </Form.Control>
                <i className="fas fa-chevron-down filter__select-icon" />
              </div>
            </Form.Group>

            <Form.Group className="filter__group">
              <Form.Label className="filter__label">
                <i className="fas fa-venus-mars" /> Gender
              </Form.Label>
              <div className="filter__select-wrapper">
                <Form.Control
                  ref={register}
                  className="filter__select"
                  as="select"
                  name="gender"
                >
                  {gender.map(gen => (
                    <option value={gen} key={gen}>
                      {gen}
                    </option>
                  ))}
                </Form.Control>
                <i className="fas fa-chevron-down filter__select-icon" />
              </div>
            </Form.Group>

            <Form.Group className="filter__group">
              <Form.Label className="filter__label">
                <i className="fas fa-calendar-alt" /> Available from
              </Form.Label>
              <div className="filter__select-wrapper">
                <Form.Control
                  ref={register}
                  className="filter__select"
                  as="select"
                  name="graduationYear"
                >
                  {years.map(year => (
                    <option value={year} key={year}>
                      {year}
                    </option>
                  ))}
                </Form.Control>
                <i className="fas fa-chevron-down filter__select-icon" />
              </div>
            </Form.Group>

            {renderOptions().length ? (
              <Form.Group className="filter__group">
                <Form.Label className="filter__label">
                  <i className="fas fa-map-marker-alt" /> Position
                </Form.Label>
                <div className="filter__select-wrapper">
                  <Form.Control
                    ref={register}
                    className="filter__select"
                    as="select"
                    name="position"
                  >
                    {renderOptions()}
                  </Form.Control>
                  <i className="fas fa-chevron-down filter__select-icon" />
                </div>
              </Form.Group>
            ) : null}
          </div>

          <div className="filter__actions">
            <Button type="submit" variant="primary">
              <i className="fas fa-search" /> Apply Filters
            </Button>
            <Button type="button" variant="outline" onClick={ResetForm}>
              <i className="fas fa-redo" /> Reset
            </Button>
            {showSaveSearch && (
              <Button type="button" variant="outline" onClick={onSaveSearch}>
                <i className="fas fa-bookmark" /> Save
              </Button>
            )}
          </div>
        </Form>
    </div>
  );
};

export default FilterBar;
